module.exports = __webpack_public_path__ + "static/media/horceracing.909886c1.png";